import { createContext } from 'react';
export var primaryDimensionListContext = createContext([]);
